import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/shell/session'
import { z } from 'zod'
import { Tag } from 'lucide-react'
import { ReleasesScreen } from '@/screens/platform/SCR-062-releases'

// SCR-062 Releases (platform area, super admins only).
export const Route = createFileRoute('/_app/platform/releases')({
  beforeLoad: requireSuperAdmin,
  staticData: { screen: { id: 'SCR-062', title: 'Releases', group: 'Platform', order: 3, platform: true, description: 'The deployed version, changelog entries, maintenance windows and incidents.', icon: Tag } },
  validateSearch: z.object({ tab: z.enum(['changelog', 'maintenance', 'incidents']).optional().catch(undefined) }),
  component: ReleasesScreen,
})
